import React from 'react';
import MembershipSignupComponent from './MembershipSignup.component';
import { MembershipSignupEditorProps } from './MembershipSignup.types';
import { adaptMembershipSignupEditorProps } from './MembershipSignup.adapter';
import './MembershipSignup.editor.css';

/**
 * 에디터 모드 멤버십 가입 컴포넌트
 */
const MembershipSignupEditor: React.FC<any> = (props) => {
  // 어댑터를 통해 props 변환
  const adaptedProps = adaptMembershipSignupEditorProps(props);
  const { isSelected, isPreview, updateComponent, viewMode, ...componentProps } = adaptedProps;

  // 미리보기 모드이거나 선택되지 않았으면 기본 컴포넌트만 렌더링
  if (isPreview || !isSelected) {
    return <MembershipSignupComponent {...componentProps} />;
  }

  // 에디터 모드에서 선택된 상태 - 리사이즈/이동 핸들 표시
  return (
    <div className="membership-editor-wrapper">
      {/* 이동 핸들 */}
      <div className="membership-editor-controls">
        <div 
          className="membership-editor-move-handle"
          data-handle="move"
        ></div>
      </div>

      {/* 실제 컴포넌트 */}
      <MembershipSignupComponent {...componentProps} />

      {/* 선택 표시 */}
      <div className="membership-editor-selection-box"></div>

      {/* 리사이즈 핸들 */}
      <div className="membership-editor-resize-handle nw" data-handle="nw"></div>
      <div className="membership-editor-resize-handle ne" data-handle="ne"></div>
      <div className="membership-editor-resize-handle sw" data-handle="sw"></div>
      <div className="membership-editor-resize-handle se" data-handle="se"></div>
    </div>
  );
};

export default MembershipSignupEditor; 